import { Link } from '@inertiajs/react'
import StatNumber from '../shared/StatNumber'

interface Props {
  icon: React.ReactNode
  label: string
  value: string
  subtitle?: string
  href: string
  statusColor?: 'green' | 'amber' | 'red' | 'neutral'
}

const STATUS_BORDER: Record<string, string> = {
  green: 'border-t-[#15532E]',
  amber: 'border-t-[#B87A20]',
  red: 'border-t-pinnacle-red',
  neutral: 'border-t-stone',
}

export default function KpiCard({ icon, label, value, subtitle, href, statusColor = 'neutral' }: Props) {
  return (
    <Link
      href={href}
      className={`bg-white rounded-lg border border-stone border-t-4 ${STATUS_BORDER[statusColor]} hover:shadow-md transition-shadow p-5 block min-w-0`}
    >
      <div className="flex items-start justify-between mb-2 gap-2">
        <span className="text-base font-bold uppercase tracking-widest text-text-secondary">{label}</span>
        <span className="text-text-muted flex-shrink-0">{icon}</span>
      </div>
      <StatNumber size="sm" className="text-text-primary">{value}</StatNumber>
      {subtitle && <p className="text-base text-text-secondary mt-1">{subtitle}</p>}
    </Link>
  )
}
